//import thu vien chart js
import Chart from "chart.js/auto";
import { Line } from "react-chartjs-2";
import { CategoryScale } from "chart.js";

//hiển thị chart theo sparkline
//chỉ hiển thị theo dữ liệu,không cần thông tin cột x,y
//data là mảng dữ liệu không cần thời gian
//[11,12,13,....]
function LineChar({dataItem,colorChart}){
Chart.register(CategoryScale);

 const data = {
    labels: dataItem,
    datasets:[
        {
            data : dataItem,
            fill:false,
            pointRadius: 0,
            spanGaps: true,
            tension: 0.2
        }
    ]
 }
 return <Line 
        data={data}
        options={{
            events: [],
            borderColor: colorChart,
            borderWidth: 1,
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false,
                labels: {
                  display: false
                }
              },
              tooltips: {
                display: false
              }
            },
            scales: {
              x: {
                display: false,
              },
              y: {
                display: false,
              }
            },
          }}
 />
}

export default LineChar;